import { render } from "./CenterPanel.vue?vue&type=template&id=2eb1ecc0&scoped=true"
import script from "./CenterPanel.vue?vue&type=script&lang=js"
export * from "./CenterPanel.vue?vue&type=script&lang=js"

import "./CenterPanel.vue?vue&type=style&index=0&id=2eb1ecc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb1ecc0"]])

export default __exports__